import { Component } from 'react';
import {
    get,
    head,
    isEqual,
    isEmpty
} from 'lodash';

import DataTypeEditor from 'common/components/DataTypeEditor/DataTypeEditor';
import AutocompleteDataSource from 'common/components/AutocompleteDataSource/AutocompleteDataSource';
import lodash from 'lodash';
import styles from '../ValueSets.scss';

class SelectList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            errorMessage: null
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (!isEqual(prevProps.validationErrors, this.props.validationErrors)) {
            this.setState({
                errorMessage: get(head(this.props.validationErrors), 'message')
            });
        }
    }

    isSelectedValueValid() {
        const { hasError } = this.state;
        return !hasError;
    }

    onValidStateChange(autocompleteSource, { hasError, editorValue }) {
        this.setState({
            hasError,
            errorMessage: null
        });
    }

    shouldShowError() {
        const { hasError } = this.state;
        const {
            value,
            validationErrors
        } = this.props;

        return hasError || (!value && !isEmpty(validationErrors));
    }

    render() {
        const {
            availableValues,
            value,
            dataType,
            changeHandler
        } = this.props;

        const { errorMessage } = this.state;
        const hasError = this.shouldShowError();

        const values = lodash.map(availableValues, (value, index) => {
            return {
                value,
                text: String(value),
                dataType,
                order: index
            };
        });

        return (
            <div className={styles.container} data-cy="selectList">
                { hasError &&
                    <span className={styles.errorMessage}>{errorMessage}</span>
                }
                <AutocompleteDataSource
                    values={values}
                    value={value}
                    onChange={changeHandler}
                    dataType={dataType}
                    onValidStateChange={this.onValidStateChange.bind(this)}
                    validate={true}>
                    <DataTypeEditor className={styles.dataTypeEditor} />
                </AutocompleteDataSource>
            </div>
        );
    }
}

export default SelectList;
